import React from 'react';


export default function MarkAsReadSelect(props) {
  const data = props.data;

  if (!data || !props.loggedIn) {
    return null;
  }

  return (
    <div>
      <label htmlFor="mark-read">{
        data?.format === 'C' || data?.format === 'N' 
        ? 'Mark as read (no rating)'
        : 'Mark as watched (no rating)'
      }</label>
      <input 
        type="checkbox" 
        id={`mark-read-${data.mediaId}`} 
        name="mark-read" 
        value="mark-read"
        style={{float: 'unset'}}
        checked={data.user_rating === -1}
        onChange={(e) => props.addRating(data.mediaIdList, data.user_rating === -1 ? 0 : -1)}
      />
    </div>
  );
}
